/* eslint-disable react/jsx-key */

import { H4 } from '@gameday/react-components/components'
import { KeyboardArrowDown } from '@material-ui/icons'
import { isEmpty } from 'lodash'
import { useState } from 'react'
import styled, { css } from 'styled-components'

import { sanitizeRichText } from '../../../../functions/richText'

const StyledContainer = styled.div`
  margin-bottom: 3em;
  > h2 {
    margin-bottom: 1em;
  }
`

const StyledMessage = styled.div`
  border-bottom: 1px solid ${props => props.theme?.colors?.border};
  padding: 0.5em 0;
`
const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem 0;
`

const Styledh4 = styled(H4)`
  padding-right: 1rem;
`
const StyledInnerMessage = styled.div`
  margin: 0 !important;
  p {
    margin: 0.5rem 0;
  }
`

const StyledChevron = styled(KeyboardArrowDown)`
  cursor: pointer;
  transition: all 0.3s ease;
  ${props =>
    props.open &&
    css`
      transform: rotate(-180deg);
    `}
`

const MessagesAccordian = ({ messages, title }) => {
  const [toggles, setToggles] = useState(
    Object.keys(messages).reduce((a, c) => {
      a[c] = true
      return a
    }, {})
  )
  return (
    !isEmpty(messages) && (
      <StyledContainer>
        {title && <h2>{title}</h2>}
        {messages.map((m, i) => (
          // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
          <StyledMessage>
            <StyledHeader onClick={() => setToggles(toggles => ({ ...toggles, [i]: !toggles[i] }))}>
              <Styledh4>{m.subText}</Styledh4>
              <StyledChevron open={toggles[i]} />
            </StyledHeader>
            {toggles[i] && (
              <StyledInnerMessage
                // eslint-disable-next-line jam3/no-sanitizer-with-danger
                // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
                dangerouslySetInnerHTML={{
                  __html: sanitizeRichText(m.message),
                }}
              />
            )}
          </StyledMessage>
        ))}
      </StyledContainer>
    )
  )
}

export default MessagesAccordian
